import { gameStorage } from "./storage";
import type { GameSettings } from "../game/types";

const PREFERENCES_KEY = "cinderwake.preferences.v2";

export const DEFAULT_SETTINGS: GameSettings = {
  reducedMotion: false,
  reduceFlashes: false,
  sound: true,
  masterVolume: 0.8,
  effectsVolume: 0.85,
  largeText: false,
  highContrast: false,
  colorVision: "standard",
  controllerHints: true,
  tutorial: true,
  showSeed: true,
  difficulty: "standard",
};

function clamp(value: unknown, fallback: number): number {
  return typeof value === "number" && Number.isFinite(value) ? Math.max(0, Math.min(1, value)) : fallback;
}

export function normalizeSettings(input?: Partial<GameSettings> | null): GameSettings {
  return {
    ...DEFAULT_SETTINGS,
    ...(input ?? {}),
    masterVolume: clamp(input?.masterVolume, DEFAULT_SETTINGS.masterVolume),
    effectsVolume: clamp(input?.effectsVolume, DEFAULT_SETTINGS.effectsVolume),
    colorVision: ["standard", "deuteranopia", "protanopia", "tritanopia"].includes(String(input?.colorVision)) ? input!.colorVision! : DEFAULT_SETTINGS.colorVision,
    difficulty: ["story", "standard", "ascendant"].includes(String(input?.difficulty)) ? input!.difficulty! : DEFAULT_SETTINGS.difficulty,
  };
}

export function loadPreferences(): GameSettings {
  try { return normalizeSettings(JSON.parse(gameStorage.getItem(PREFERENCES_KEY) ?? "null") as Partial<GameSettings> | null); }
  catch { return { ...DEFAULT_SETTINGS }; }
}

export function savePreferences(settings: GameSettings): void {
  try { gameStorage.setItem(PREFERENCES_KEY, JSON.stringify(normalizeSettings(settings))); } catch { /* optional */ }
}

export function applyPreferences(settings: GameSettings): void {
  const root = document.documentElement;
  root.dataset.colorVision = settings.colorVision;
  root.classList.toggle("pref-large-text", settings.largeText);
  root.classList.toggle("pref-high-contrast", settings.highContrast);
  root.classList.toggle("pref-reduced-motion", settings.reducedMotion);
  root.classList.toggle("pref-reduced-flashes", settings.reduceFlashes);
}
